import React from 'react';
import { StatusBar } from 'expo-status-bar';
import AppLoading from 'expo-app-loading';
import { DefaultTheme, Provider as PaperProvider } from 'react-native-paper';
import { Provider } from 'react-redux';
import { NavigationContainer } from '@react-navigation/native';
import { useFonts } from 'expo-font';
import EStyleSheet from 'react-native-extended-stylesheet';
import { SafeAreaProvider } from 'react-native-safe-area-context';

import store from './app/store';
import { BaseNavigator } from './app/navigators';
import { appColors } from './app/assets/styles/global';

EStyleSheet.build();

export default function App() {
  const [fontsLoaded] = useFonts({
    MBold: require('./app/assets/fonts/Montserrat-Bold.ttf'),
    MRegular: require('./app/assets/fonts/Montserrat-Regular.ttf'),
    MMedium: require('./app/assets/fonts/Montserrat-Medium.ttf'),
  });

  const theme = {
    ...DefaultTheme,
    dark: false,
    mode: 'exact',
  };
  return (
    !fontsLoaded
      ? <AppLoading />
      : (
        <Provider store={store}>
          <StatusBar style="inverted" animated backgroundColor={appColors.primary} />
          <SafeAreaProvider>
            <NavigationContainer>
              <PaperProvider theme={theme}>
                <BaseNavigator />
              </PaperProvider>
            </NavigationContainer>
          </SafeAreaProvider>
        </Provider>
      )
  );
}
